var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('user-standard-avatar',{staticClass:"border-light border-top",attrs:{"standardMap":_vm.standardMap,"nonPrimaryPhotos":false,"hideBadges":true,"userBetweenStatus":false,"size":"small"}},[_c('livestream-billing')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }